<div #wrapper class="view-recipe-wrapper">
    <app-modal-header [text]="recipe?.title" [bold]="true" (close)="bsModalRef.hide()"></app-modal-header>

    <ng-container *ngIf="!loading">
        <div class="modal-body" [ngClass]="isIOS() === true ? 'ios' : ''">
            <div
                    id="main-image"
                    *ngIf="recipeImages.length > 0"
                    [lazyLoad]="constants.imagesUrl() + '/images/850x500/' + recipeImages[0].type + '/' + recipeImages[0].name"
                    class="animated fadeIn">
                <div class="star-image"
                     *ngIf="recipe.influencer && recipe.influencer.images && recipe.influencer.images.length > 0"
                     [lazyLoad]="constants.imagesUrl() + '/images/600x350/' + recipe.influencer.images[0].type + '/' + recipe.influencer.images[0].name + '/'"
                ></div>

                <div class="recipe-calories">
                    <span>{{ sumWeight(products, productCalculationsByProductId) }} {{ 'abbreviation_gram' | localise }}</span>
                </div>
            </div>

            <div class="form-group" *ngIf="showMacros === true">
                <app-nutrients-breakdown [horizontal]="true"
                                         [calculations]="diaryRecipe?.macros || mealRecipe?.macros"></app-nutrients-breakdown>
            </div>

            <ng-container *ngIf="showFriends">
                <div id="friends-weight">
                    <div class="form-group">
                        <div class="font-weight-600 ">
                            {{ 'gramaj' | localise }} (You)
                        </div>
                        {{ sumWeight(products, productCalculationsByProductId) }} {{ 'abbreviation_gram' | localise }}
                    </div>

                    <div
                            *ngFor="let friendId of onlyKeys(friends)"
                            class="form-group">
                        <div class="font-weight-600"
                             [ngStyle]="{color:friends[friendId].color}">
                            {{ getShortName(friends[friendId].friend.first_name, friends[friendId].friend.last_name) }}
                        </div>
                        {{ sum_diary_products_weight(friends[friendId].products) }} {{ 'abbreviation_gram' | localise }}
                    </div>
                </div>
                <div class="clearfix"></div>
            </ng-container>

            <div class="table-responsive form-group" style="overflow: initial !important;">
                <h2 class="view-recipe-title">{{ 'main_products' | localise }}</h2>
                <table class="table" style="table-layout: fixed;">
                    <tbody>
                    <ng-container *ngFor="let product of products">
                        <tr *ngIf="product.category.id !== 34">
                            <td class="title-td" [ngStyle]="{width: (showFriends ? '' : '69%')}" style="padding: 10px 0px; white-space: initial !important;">
                                <ng-container *ngIf="product.images.length > 0">
                                    <div
                                            [ngStyle]="{'background': 'url(\''+constants.imagesUrl() + '/images/100x100/' + product.images[0].type + '/' + product.images[0].name + '/'+'\') center center no-repeat', 'background-size': 'contain'}"
                                            style="
                                    width: 56px;
                                    height: 56px;
                                    float: left;
                                "></div>
                                </ng-container>


                                <div style="float: left; line-height: 1.3rem; padding: 6px 12px;">
                                    {{ product.title }}
                                    <br/>
                                    <ng-container *ngIf="product.type_calculation === 'WEIGHT'">
                                        <strong>
                                            {{ round(+productCalculationsByProductId[product.id].weight) }}
                                            {{ 'abbreviation_gram' | localise }}
                                        </strong>
                                    </ng-container>

                                    <ng-container *ngIf="product.type_calculation === 'QTY'">
                                        <strong>
                                            {{ productCalculationsByProductId[product.id].qty }}
                                            {{ 'br' | localise }}
                                        </strong>
                                    </ng-container>

                                    <ng-container *ngIf="showFriends">
                                        <ng-container
                                                *ngFor="let friendId of onlyKeys(friends)">
                                            <br/>
                                            {{ getShortName(friends[friendId].friend.first_name, friends[friendId].friend.last_name) }}:

                                            <ng-container *ngFor="let friendProduct of friends[friendId].products">
                                                <ng-container *ngIf="friendProduct.product.id === product.id">
                                                    <ng-container *ngIf="friendProduct.product.type_calculation === 'WEIGHT'">
                                                        <strong>
                                                            {{ round(+friendProduct.weight) }}
                                                            {{ 'abbreviation_gram' | localise }}
                                                        </strong>
                                                    </ng-container>

                                                    <ng-container *ngIf="friendProduct.product.type_calculation === 'QTY'">
                                                        <strong>
                                                            {{ friendProduct.qty }}
                                                            {{ 'br' | localise }}
                                                        </strong>
                                                    </ng-container>
                                                </ng-container>
                                            </ng-container>
                                        </ng-container>
                                    </ng-container>
                                </div>

                                <div style="clear: both;"></div>
                            </td>

                            <td class="text-align-center">
                                <button
                                        *ngIf="this.diaryRecipe"
                                        (click)="openChangeDiaryRecipeProduct(product.id)"
                                        type="button"
                                        class="btn btn-primary btn-icon-text how-to-cook-btn change-btn">
                                    <i class="fa-exchange fa btn-icon-prepend"></i>
                                    {{ 'change_product_modal_replace' | localise }}
                                </button>

                                <button
                                        *ngIf="this.diaryRecipe"
                                        (click)="deleteProductFromDiaryRecipe(product.id)"
                                        type="button"
                                        class="btn btn-primary btn-icon-text how-to-cook-btn delete-btn">
                                    <i class="fa-trash-o fa btn-icon-prepend"></i>
                                    {{ 'delete_product' | localise }}
                                </button>
                            </td>

                        </tr>
                    </ng-container>
                    </tbody>
                </table>
            </div>

            <div class="table-responsive form-group" style="overflow: initial !important;">
                <h2 class="view-recipe-title">{{ 'spices' | localise }}</h2>
                <table class="table" style="table-layout: fixed;">
                    <tbody>
                    <ng-container *ngFor="let product of products">
                        <tr *ngIf="product.category.id === 34">
                            <td class="title-td" [ngStyle]="{width: (showFriends ? '' : '69%')}" style="padding: 10px 0px; white-space: initial !important;">
                                <ng-container *ngIf="product.images.length > 0">
                                    <div
                                            [ngStyle]="{'background': 'url(\''+constants.imagesUrl() + '/images/100x100/' + product.images[0].type + '/' + product.images[0].name + '/'+'\') center center no-repeat', 'background-size': 'contain'}"
                                            style="
                                    width: 56px;
                                    height: 56px;
                                    float: left;
                                "></div>
                                </ng-container>


                                <div style="float: left; line-height: 1.3rem; padding: 6px 12px;">
                                    {{ product.title }}
                                    <br/>
                                    <ng-container *ngIf="product.type_calculation === 'WEIGHT'">
                                        <strong>
                                            {{ round(+productCalculationsByProductId[product.id].weight) }}
                                            {{ 'abbreviation_gram' | localise }}
                                        </strong>
                                    </ng-container>

                                    <ng-container *ngIf="product.type_calculation === 'QTY'">
                                        <strong>
                                            {{ productCalculationsByProductId[product.id].qty }}
                                            {{ 'br' | localise }}
                                        </strong>
                                    </ng-container>

                                    <ng-container *ngIf="showFriends">
                                        <ng-container
                                                *ngFor="let friendId of onlyKeys(friends)">
                                            <br/>
                                            {{ getShortName(friends[friendId].friend.first_name, friends[friendId].friend.last_name) }}:

                                            <ng-container *ngFor="let friendProduct of friends[friendId].products">
                                                <ng-container *ngIf="friendProduct.product.id === product.id">
                                                    <ng-container *ngIf="friendProduct.product.type_calculation === 'WEIGHT'">
                                                        <strong>
                                                            {{ round(+friendProduct.weight) }}
                                                            {{ 'abbreviation_gram' | localise }}
                                                        </strong>
                                                    </ng-container>

                                                    <ng-container *ngIf="friendProduct.product.type_calculation === 'QTY'">
                                                        <strong>
                                                            {{ friendProduct.qty }}
                                                            {{ 'br' | localise }}
                                                        </strong>
                                                    </ng-container>
                                                </ng-container>
                                            </ng-container>
                                        </ng-container>
                                    </ng-container>
                                </div>

                                <div style="clear: both;"></div>
                            </td>

                            <td class="text-align-center">
                                <button
                                        *ngIf="this.diaryRecipe"
                                        (click)="openChangeDiaryRecipeProduct(product.id)"
                                        type="button"
                                        class="btn btn-primary btn-icon-text how-to-cook-btn">
                                    <i class="fa-exchange fa btn-icon-prepend"></i>
                                    {{ 'change_product_modal_replace' | localise }}
                                </button>
                            </td>
                        </tr>
                    </ng-container>
                    </tbody>
                </table>
            </div>

            <div class="form-group" *ngIf="recipe.allergies.length">
                <h2 class="view-recipe-title">{{ 'allergens' | localise }}</h2>
                <ul class="m-0">
                    <li *ngFor="let allergy of recipe.allergies">{{ allergy.title }}</li>
                </ul>
            </div>

            <div class="form-group">
                <button
                        type="button"
                        *ngIf="showHowToCook === false"
                        (click)="showHowToCook = true"
                        class="btn btn-primary btn-icon-text how-to-cook-btn">
                    <i class="fa-info-circle fa btn-icon-prepend"></i>
                    {{ 'how_to_cook' | localise }}
                </button>

                <ng-container *ngIf="showHowToCook">
                    <h2 class="view-recipe-title">{{ 'how_to_cook' | localise }}</h2>
                    <div class="recipe-text" [innerHTML]="recipe.how_to_cook_text | keepHtml"></div>

                    <div *ngIf="recipeEmbedCode">
                        <iframe
                                frameborder="0"
                                [src]="sanitizer.bypassSecurityTrustResourceUrl('https://www.youtube.com/embed/' + recipeEmbedCode)"
                                width="100%"
                                height="360"></iframe>
                    </div>

                    <ng-container *ngFor="let product of products">
                        <ng-container *ngIf="product.measuring_units_text && product.measuring_units_text.length > 0">
                            <div class="font-weight-600 ">{{ product.title }}</div>
                            <p [innerHTML]="product.measuring_units_text"></p>
                        </ng-container>
                    </ng-container>
                </ng-container>
            </div>
        </div>

        <div class="modal-footer" [ngClass]="isIOS() === true ? 'ios' : ''">
            <button type="button" class="btn btn-secondary" (click)="bsModalRef.hide()">{{ 'back' | localise }}</button>
            <button *ngIf="mealRecipe" type="button" class="btn btn-success"
                    (click)="onAdd()">{{ 'add' | localise }}</button>
        </div>
    </ng-container>
    <ng-container *ngIf="loading">
        <app-loading></app-loading>
    </ng-container>
</div>
